/**
 * Checks if the passed argument is an Object
 * and returns the result
 */

// isObject :: a -> Boolean
function isObject(value: unknown): value is object {
  return typeof value === 'object' && value !== null;
}

export default isObject;
